<template>
  <div class="row">
    <div class="col-12">
      <card>
        <h2 class="card-title">{{ $t('defaultMonitorsPanel.cardTitle') }}</h2>
        <div class="table-responsive">
          <b-table
            striped
            hover
            sticky-header
            id="default-monitors-table"
            :fields="fields"
            :items="tableItems"
            selectable
            :select-mode="'single'"
            @row-selected="onRowSelected">
            <template #cell(enabled)="data">
              <i v-if="data.value" class="fas fa-check" style="color: green"></i>
              <i v-else class="fas fa-times" style="color: red"></i>
            </template>
          </b-table>
        </div>
        <div slot="footer" class="button-row">
          <div class="button-container">
            <base-button type="danger-nogradient" @click="$router.push('alerts-panel')" fill>{{ $t('defaultMonitorsPanel.backButton') }}</base-button>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Card from '@/components/Cards/Card.vue'
import { batteryTechEnum } from '@/config/env'

export default {
  components: { Card },
  data() {
    return {
      batteryTechEnum,
      fields: []
    }
  },
  computed: {
    tableItems() {
      return Object.entries(this.batteryTechEnum).map(([techBatt, label]) => {
        const monitor = this.monitors.find(m => m.isDefault && Number(m.techBatt) === Number(techBatt))
        return {
          techBatt: Number(techBatt),
          techBattLabel: label,
          enabled: monitor ? !!monitor.enabled : false,
          elemVmin: monitor ? monitor.elemVmin : '-',
          elemVmcv: monitor ? monitor.elemVmcv : '-',
          minDuration: monitor ? monitor.minDuration : '-',
          Tmin: monitor ? monitor.Tmin : '-',
          Tmax: monitor ? monitor.Tmax : '-',
          numCycles: monitor ? monitor.numCycles : '-',
        }
      })
    },
    locale() {
      return this.$i18n.locale
    },
    ...mapState(['monitors', 'isAdmin'])
  },
  watch: {
    locale() {
      this.computeFields()
    }
  },
  mounted() {
    this.$store.dispatch('updateMonitors')
    this.computeFields()
  },
  methods: {
    computeFields() {
      this.fields = [
        { key: 'techBattLabel', label: this.$t('defaultMonitorsPanel.technology') },
        { key: 'enabled', label: this.$t('defaultMonitorsPanel.enabled') },
        { key: 'elemVmin', label: this.$t('alertsPanel.cellsUndervoltageThreshold') },
        { key: 'elemVmcv', label: this.$t('alertsPanel.cellsMinChargingVoltage') },
        { key: 'minDuration', label: this.$t('editMonitor.minChargingTime') },
        { key: 'Tmin', label: this.$t('alertsPanel.minTemp') },
        { key: 'Tmax', label: this.$t('alertsPanel.maxTemp') },
        { key: 'numCycles', label: this.$t('alertsPanel.numCycles') },
      ]
    },
    onRowSelected(items) {
      const row = items[0]
      if (row) {
        localStorage.setItem('selectedDefaultMonitorTech', JSON.stringify(row.techBatt))
        this.$router.push('edit-default-monitor')
      }
    }
  }
}
</script>

